export const requestStatusText = {
  no_process: "Đang chờ xử lý",
  approved: "Đã xử lý thành công",
  removed: "Đã từ chối",
};

export const requestTypeText = {
  full_name: "Thay đổi họ và tên",
  phone_number: "Thay đổi số điện thoại",
  email: "Thay đổi email",
  bank: "Thay đổi tài khoản ngân hàng",
  birthday: "Thay đổi ngày sinh",
  forget_password: "Cấp lại mật khẩu đăng nhập",
  forget_password_withdraw: "Cấp lại mật khẩu rút tiền",
};

export const getVerificationStatusText = (status, sendType) => {
  if (status === "success") return "Đã nhận xác thực hợp lệ";
  if (status === "invalid") {
    return sendType === "email"
      ? "Đã nhận email nhưng sai địa chỉ email gửi đến"
      : "Đã nhận SMS nhưng sai số điện thoại gửi đến";
  }
  return sendType === "email"
    ? "Chưa nhận được email xác thực"
    : "Chưa nhận được SMS xác thực";
};

export const maskRequestCode = (code = "") => {
  const value = String(code);
  return value.startsWith("xxxxx") ? value : `xxxxx${value.slice(-3)}`;
};
